/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Filterable_Select_Clear_SelectionInputs */

const en_forms_filterable_select_clear_selection = /** @type {(inputs: Forms_Filterable_Select_Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear selection`)
};

/** @type {(inputs: Forms_Filterable_Select_Clear_SelectionInputs) => LocalizedString} */
const de_forms_filterable_select_clear_selection = en_forms_filterable_select_clear_selection;

/** @type {(inputs: Forms_Filterable_Select_Clear_SelectionInputs) => LocalizedString} */
const es_forms_filterable_select_clear_selection = en_forms_filterable_select_clear_selection;

/** @type {(inputs: Forms_Filterable_Select_Clear_SelectionInputs) => LocalizedString} */
const fr_forms_filterable_select_clear_selection = en_forms_filterable_select_clear_selection;

/** @type {(inputs: Forms_Filterable_Select_Clear_SelectionInputs) => LocalizedString} */
const it_forms_filterable_select_clear_selection = en_forms_filterable_select_clear_selection;

/** @type {(inputs: Forms_Filterable_Select_Clear_SelectionInputs) => LocalizedString} */
const pt_br2_forms_filterable_select_clear_selection = en_forms_filterable_select_clear_selection;

/** @type {(inputs: Forms_Filterable_Select_Clear_SelectionInputs) => LocalizedString} */
const pl_forms_filterable_select_clear_selection = en_forms_filterable_select_clear_selection;

/** @type {(inputs: Forms_Filterable_Select_Clear_SelectionInputs) => LocalizedString} */
const hu_forms_filterable_select_clear_selection = en_forms_filterable_select_clear_selection;

/** @type {(inputs: Forms_Filterable_Select_Clear_SelectionInputs) => LocalizedString} */
const ro_forms_filterable_select_clear_selection = en_forms_filterable_select_clear_selection;

/**
* | output |
* | --- |
* | "Clear selection" |
*
* @param {Forms_Filterable_Select_Clear_SelectionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const forms_filterable_select_clear_selection = /** @type {((inputs?: Forms_Filterable_Select_Clear_SelectionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Filterable_Select_Clear_SelectionInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_filterable_select_clear_selection(inputs)
	if (locale === "de") return de_forms_filterable_select_clear_selection(inputs)
	if (locale === "es") return es_forms_filterable_select_clear_selection(inputs)
	if (locale === "fr") return fr_forms_filterable_select_clear_selection(inputs)
	if (locale === "it") return it_forms_filterable_select_clear_selection(inputs)
	if (locale === "pt-BR") return pt_br2_forms_filterable_select_clear_selection(inputs)
	if (locale === "pl") return pl_forms_filterable_select_clear_selection(inputs)
	if (locale === "hu") return hu_forms_filterable_select_clear_selection(inputs)
	return ro_forms_filterable_select_clear_selection(inputs)
});
export { forms_filterable_select_clear_selection as "forms.filterable_select.clear_selection" }